<div class="container">
  <app-notification *ngIf="this.errorMsg != null" [content]="this.errorMsg"  (notificationClosed)="this.errorMsg = null" timeOut="5000" display="true" data-testid="error-notification"
                    error=true></app-notification>
  <app-notification *ngIf="showSuccessNotification" [content]="'Die Änderungen wurden übernommen.'" timeOut="5000" display="true" (notificationClosed)="showSuccessNotification = false"
                    success=true data-testid="success-notification"></app-notification>
</div>

<div *ngIf="user" class="container settings" style="margin-top: 3rem" data-testid="div-container">
  <div class="columns">
    <div class="column is-6">
      <div class="card has-round-border">
        <div class="card-content">
          <ul>
            <li>
              <span class="has-text-weight-semibold">Kundennummer:</span>
              <span data-testid="user-id">{{user.id}}</span>
            </li>
            <li>
              <span class="has-text-weight-semibold">Unternehmen:</span>
              <span data-testid="user-company">{{currentMultiUserPlatform?.company ?? "-"}}</span>
            </li>
            <li>
              <span class="has-text-weight-semibold">Vorname:</span>
              <span data-testid="user-firstname">{{user.firstname}}</span>
            </li>
            <li>
              <span class="has-text-weight-semibold">Nachname:</span>
              <span data-testid="user-lastname">{{user.lastname}}</span>
            </li>
            <li>
              <span class="has-text-weight-semibold">Straße:</span>
              <span data-testid="user-street">{{user.street}}</span>
            </li>
            <li>
              <span class="has-text-weight-semibold">PLZ:</span>
              <span data-testid="user-zip">{{user.zip}}</span>
            </li>
            <li>
              <span class="has-text-weight-semibold">Stadt:</span>
              <span data-testid="user-town">{{user.town}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="column is-6">
      <div class="card has-round-border">
        <h2 class="title is-4 is-darkblue">Sicherheitseinstellungen:</h2>
        <a data-testid="change-password-modal-button" [href]="'https://authentication.docestate.com/realms/'+ environment.realm +'/protocol/openid-connect/auth?response_type=code&client_id=CONNECTFRONTEND&redirect_uri=' + window.location.origin + '&kc_action=UPDATE_PASSWORD'">Passwort ändern</a>
      </div>
    </div>
  </div>
</div>

<app-modal id="change-password-modal" [active]="showChangePasswordModal" (modalClosed)="showChangePasswordModal=false;resetChangePasswordForm()" data-testid="change-password-modal">
  <div class="title is-4">Passwort</div>
  <form id="newPasswordForm" [formGroup]="newPasswordForm">

    <label for="oldpass" style="margin-right: 109px">Altes Passwort </label>
    <input id="oldpass" class="input" name="oldpassword" type="password" formControlName="oldPassword"/><br>

    <label for="pass" style="margin-right: 100px">Neues Passwort </label>
    <input id="pass" name="password" class="input" type="password" formControlName="password"/><br>

    <label for="passConfirm" style="margin-right: 13px">Neues Passwort wiederholen</label>
    <input id="passConfirm" class="input" type="password" formControlName="passwordConfirm"/><br>
    <p>Jedes Passwort benötigt:</p>
    <ul style="padding-left: 40px; list-style: disc;">
      <li [ngStyle]="newPasswordForm.controls['password'].hasError('required') || newPasswordForm.controls['password'].hasError('minlength') ? {'color':'red'} : {'color':'green'}" data-testid="password-length">Mindestens 8 Zeichen</li>
      <li [ngStyle]="newPasswordForm.controls['password'].hasError('required') || newPasswordForm.controls['password'].hasError('hasNumber') ? {'color':'red'} : {'color':'green'}" data-testid="password-number">Mindestens eine Zahl</li>
      <li [ngStyle]="newPasswordForm.controls['password'].hasError('required') || newPasswordForm.controls['password'].hasError('hasBigLetter') ? {'color':'red'} : {'color':'green'}" data-testid="password-big-letter">Mindestens einen Großbuchstaben</li>
      <li [ngStyle]="newPasswordForm.controls['password'].hasError('required') || newPasswordForm.controls['password'].hasError('hasSmallLetter') ? {'color':'red'} : {'color':'green'}" data-testid="password-small-letter">Mindestens einen Kleinbuchstaben</li>
      <li [ngStyle]="newPasswordForm.controls['password'].hasError('required') || newPasswordForm.controls['password'].hasError('hasSpecialCharacter') ? {'color':'red'} : {'color':'green'}" data-testid="password-special-letter">Mindestens ein Sonderzeichen</li>
    </ul>

    <p>&nbsp;</p>
    <p *ngIf="newPasswordForm.controls['passwordConfirm'].hasError('NoPassswordMatch')" style="color: red" data-testid="passwords-equal">Passwörter stimmen nicht überein</p>
    <button type="submit" class="button" (click)="updatePassword()" data-testid="update-password">Passwort ändern</button>
  </form>
</app-modal>

